var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerformanceScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.66 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:#ff7805;}.f{fill:none;stroke:#ff7805;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M64.64,39.1c.34,6.47-3.83,10.89-10.17,10.89-14.84,0-29.67,0-44.51,0-6.17,0-10.45-4.66-9.93-10.9H25.11v2.98h14.36v-2.97h25.17ZM2.42,41.3c.31,3.51,3.37,6.26,6.9,6.28,4.86,.03,9.72,0,14.58,0,10.44,0,20.87,.01,31.31,0,3.64,0,6.8-2.82,6.99-6.26h-20.26l-.15,3.12H22.78v-3.14H2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M7.62,35.1h-2.13c0-.59,0-1.13,0-1.67,0-9.16,0-18.32,0-27.48C5.49,2.05,7.54,0,11.46,0c13.3,0,26.61,0,39.91,0,3.9,0,5.95,2.06,5.96,5.98,0,9.21,0,18.42,0,27.63v1.45h-2.13v-1.78c0-9.01,0-18.01,0-27.02,0-2.84-1.07-3.95-3.85-3.95-13.3,0-26.61-.01-39.91,0-2.74,0-3.8,1.09-3.81,3.81,0,9.06,0,18.11,0,27.17,0,.55,0,1.11,0,1.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "14.81 26.32 23.56 18.19 32.03 26.32 44.33 14.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "34.65 13.98 44.79 13.98 44.79 23.49"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceScan);
export default __webpack_public_path__ + "static/media/Performance Scan.fef56c588f3e97df5fa66fb453b9e533.svg";
export { ForwardRef as ReactComponent };